import { AccountType } from "cy-remittance/registration";
import { AccountTypes } from "./models";
import { ReactNode } from "react";

export function renderAccountType(
  accountType: AccountType<AccountTypes>,
): ReactNode {
  return <p>{accountType.description}</p>;
}
